import { createAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { showNotificationAsync } from '../notifications/actions';
import { RootState } from '../store';
import { selectUserDetailsLoading } from './selectors';
import * as usersService from './service';
import type { UserDataModel } from './types';

export const setUserRecords = createAction(
    '@@users/SET_USER_RECORDS',
    (...payload: UserDataModel[]) => ({ payload }),
);

type SetUserDetailsLoadingPayload = {
    id: string;
    isLoading: boolean;
};

export const setUserDetailsLoading = createAction<SetUserDetailsLoadingPayload>(
    '@@users/SET_USER_DETAILS_LOADING',
);

export function loadUserByIdAsync(id: string): ThunkAction<void, RootState, undefined, AnyAction> {
    return async (dispatch, getState) => {
        const state = getState();
        const isLoading = selectUserDetailsLoading(state, id);

        if (isLoading) {
            return;
        }

        dispatch(setUserDetailsLoading({ id, isLoading: true }));

        try {
            const user = await usersService.loadUser(id);
            dispatch(setUserRecords(user));
        } catch (e) {
            const error = e as AxiosError;
            if (error.response && error.response.status === 401) {
                refreshSession();
            } else {
                dispatch(showNotificationAsync('Не удалось загрузить данные'));
            }
        }

        dispatch(setUserDetailsLoading({ id, isLoading: false }));
    };
}

async function refreshSession() {
    window.location.href = `${process.env.REACT_APP_PASSPORT_URL}/auth?retpath=${window.location.href}`;
}
